import api from '@mint-lib/api';
import { useCrucialQuery, useQueryClient } from '@mint-lib/query-client';
import { getRouteApi } from '@mint/routing';

import { QueryKey } from '../constants/queryKeys.js';
import {
  BuyingPlanLite,
  BuyingPlanLiteListSchema,
} from '../types/buyingPlan.js';

const getBuyingPlanList = async (campaignId: string) => {
  const response = await api.get('api/datintell/v1/builder/media_plans/', {
    params: {
      campaign_collection: campaignId,
      ordering: 'id',
    },
  });

  return BuyingPlanLiteListSchema.parse(response.data);
};

const routeApi = getRouteApi(
  '/_secured/campaign/$campaignId/planning/buying-plan',
);

type Options = {
  skip?: boolean;
};

export const useGetBuyingPlanListData = (options?: Options) => {
  const params = routeApi.useParams();
  const { data, isLoading, isError } = useCrucialQuery({
    queryKey: [QueryKey.BUYING_PLAN_LIST, params.campaignId],
    queryFn: () => getBuyingPlanList(params.campaignId),
    staleTime: Infinity,
    enabled: !options?.skip,
  });
  return { data, isLoading, isError };
};

export const useBuyingPlanListSelector = () => {
  const queryClient = useQueryClient();
  const params = routeApi.useParams();

  return queryClient.getQueryData<BuyingPlanLite[]>([
    QueryKey.BUYING_PLAN_LIST,
    params.campaignId,
  ]);
};
